'use client';


import Header from '@/components/common/Header';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import MapSection from './components/MapSection';
import BusinessHours from './components/BusinessHours';
import ContactInteractive from './components/ContactInteractive';
import { useLanguage } from '@/contexts/LanguageContext';

interface ContactDetail {
  id: number;
  icon: string;
  title: string;
  details: string[];
  link?: string;
}

interface Location {
  id: number;
  name: string;
  address: string;
  lat: number;
  lng: number;
}

interface DaySchedule {
  day: string;
  hours: string;
  isToday: boolean;
}

interface InquiryType {
  id: string;
  label: string;
  icon: string;
}

export default function ContactPage() {
  const { t } = useLanguage();

  const contactDetails: ContactDetail[] = [
    {
      id: 1,
      icon: 'PhoneIcon',
      title: t('contact.info.phone'),
      details: ['0242 2304030', '0542 782 46 37'],
      link: 'tel:+902422304030',
    },
    {
      id: 2,
      icon: 'EnvelopeIcon',
      title: t('contact.info.email'),
      details: ['info@sidemgida.com', 'satis@sidemgida.com'],
      link: 'mailto:info@sidemgida.com',
    },
    {
      id: 3,
      icon: 'MapPinIcon',
      title: t('contact.info.address'),
      details: [
        'COFFEETAINER',
        'Altınkum Mahallesi, 432. Sokak',
        'Çamlık Caddesi, Koçak Apt. No:6, D-1',
        'Konyaaltı, Antalya',
      ],
    },
    {
      id: 4,
      icon: 'ChatBubbleLeftRightIcon',
      title: t('contact.info.whatsapp'),
      details: ['+90 542 782 46 37', t('contact.info.whatsapp.support')],
      link: 'https://wa.me/905427824637',
    },
  ];

  const location: Location = {
    id: 1,
    name: t('contact.map.title'),
    address: 'Altınkum Mahallesi, 432. Sokak, Çamlık Caddesi, Koçak Apt. No:6, D-1, Konyaaltı, Antalya',
    lat: 36.8899,
    lng: 30.6845,
  };

  const businessSchedule: DaySchedule[] = [
    { day: t('contact.hours.monday'), hours: '08:00 - 18:00', isToday: false },
    { day: t('contact.hours.tuesday'), hours: '08:00 - 18:00', isToday: true },
    { day: t('contact.hours.wednesday'), hours: '08:00 - 18:00', isToday: false },
    { day: t('contact.hours.thursday'), hours: '08:00 - 18:00', isToday: false },
    { day: t('contact.hours.friday'), hours: '08:00 - 18:00', isToday: false },
    { day: t('contact.hours.saturday'), hours: '09:00 - 15:00', isToday: false },
    { day: t('contact.hours.sunday'), hours: t('contact.hours.closed'), isToday: false },
  ];

  const inquiryTypes: InquiryType[] = [
    { id: 'wholesale', label: t('contact.form.type.wholesale'), icon: 'ShoppingCartIcon' },
    { id: 'partnership', label: t('contact.form.type.partnership'), icon: 'HandshakeIcon' },
    { id: 'technical', label: t('contact.form.type.technical'), icon: 'WrenchScrewdriverIcon' },
    { id: 'general', label: t('contact.form.type.general'), icon: 'InformationCircleIcon' },
    { id: 'complaint', label: t('contact.form.type.complaint'), icon: 'ChatBubbleLeftEllipsisIcon' },
    { id: 'quality', label: t('contact.form.type.quality'), icon: 'ShieldCheckIcon' },
  ];

  return (
    <div data-component-id="src/app/contact/page.tsx:106:4" data-component-path="src/app/contact/page.tsx" data-component-line="106" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
      <Header data-component-id="src/app/contact/page.tsx:107:6" data-component-path="src/app/contact/page.tsx" data-component-line="107" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />

      <main data-component-id="src/app/contact/page.tsx:109:6" data-component-path="src/app/contact/page.tsx" data-component-line="109" data-component-file="page.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22pt-20%22%7D" className="pt-20">
        <ContactHero data-component-id="src/app/contact/page.tsx:110:8" data-component-path="src/app/contact/page.tsx" data-component-line="110" data-component-file="page.tsx" data-component-name="ContactHero" data-component-content="%7B%22elementName%22%3A%22ContactHero%22%7D"
          title={t('contact.hero.title')}
          subtitle={t('contact.hero.subtitle')}
        />

        <section data-component-id="src/app/contact/page.tsx:115:8" data-component-path="src/app/contact/page.tsx" data-component-line="115" data-component-file="page.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20lg%3Apy-24%22%7D" className="py-16 lg:py-24">
          <div data-component-id="src/app/contact/page.tsx:116:10" data-component-path="src/app/contact/page.tsx" data-component-line="116" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="container mx-auto px-6 lg:px-12">
            <ContactInfo data-component-id="src/app/contact/page.tsx:117:12" data-component-path="src/app/contact/page.tsx" data-component-line="117" data-component-file="page.tsx" data-component-name="ContactInfo" data-component-content="%7B%22elementName%22%3A%22ContactInfo%22%7D" contactDetails={contactDetails} />
          </div>
        </section>

        <ContactInteractive data-component-id="src/app/contact/page.tsx:121:8" data-component-path="src/app/contact/page.tsx" data-component-line="121" data-component-file="page.tsx" data-component-name="ContactInteractive" data-component-content="%7B%22elementName%22%3A%22ContactInteractive%22%7D"
          inquiryTypes={inquiryTypes}
        />

        <section data-component-id="src/app/contact/page.tsx:125:8" data-component-path="src/app/contact/page.tsx" data-component-line="125" data-component-file="page.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20lg%3Apy-24%22%7D" className="py-16 lg:py-24">
          <div data-component-id="src/app/contact/page.tsx:126:10" data-component-path="src/app/contact/page.tsx" data-component-line="126" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="container mx-auto px-6 lg:px-12">
            <div data-component-id="src/app/contact/page.tsx:127:12" data-component-path="src/app/contact/page.tsx" data-component-line="127" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-3%20gap-8%22%7D" className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div data-component-id="src/app/contact/page.tsx:128:14" data-component-path="src/app/contact/page.tsx" data-component-line="128" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%22%7D" className="lg:col-span-2">
                <MapSection data-component-id="src/app/contact/page.tsx:129:16" data-component-path="src/app/contact/page.tsx" data-component-line="129" data-component-file="page.tsx" data-component-name="MapSection" data-component-content="%7B%22elementName%22%3A%22MapSection%22%7D" location={location} />
              </div>
              <div data-component-id="src/app/contact/page.tsx:131:14" data-component-path="src/app/contact/page.tsx" data-component-line="131" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
                <BusinessHours data-component-id="src/app/contact/page.tsx:132:16" data-component-path="src/app/contact/page.tsx" data-component-line="132" data-component-file="page.tsx" data-component-name="BusinessHours" data-component-content="%7B%22elementName%22%3A%22BusinessHours%22%7D" schedule={businessSchedule} />
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer data-component-id="src/app/contact/page.tsx:139:6" data-component-path="src/app/contact/page.tsx" data-component-line="139" data-component-file="page.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%2C%22className%22%3A%22bg-foreground%20text-background%20py-8%22%7D" className="bg-foreground text-background py-8">
        <div data-component-id="src/app/contact/page.tsx:140:8" data-component-path="src/app/contact/page.tsx" data-component-line="140" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-6%20lg%3Apx-12%20text-center%22%7D" className="container mx-auto px-6 lg:px-12 text-center">
          <p data-component-id="src/app/contact/page.tsx:141:10" data-component-path="src/app/contact/page.tsx" data-component-line="141" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-body%20opacity-80%22%2C%22textContent%22%3A%22%C2%A9%20Sidem%20G%C4%B1da.%22%7D" className="text-sm font-body opacity-80">
            &copy; {new Date().getFullYear()} Sidem Gıda. {t('footer.allRights')}
          </p>
        </div>
      </footer>
    </div>
  );
}